module.exports = __webpack_public_path__ + "assets/icn-migrate.72eaef61.svg";